import AuthService from "../services/auth.service";

// Load user from localStorage
const stored = localStorage.getItem("user_free");
const user = stored ? JSON.parse(stored) : null;

const initialState = {
  user: user,
  loggedIn: !!user,
};

export const auth = {
  namespaced: true,

  state: initialState,

  getters: {
    isLoggedIn(state) {
      return state.loggedIn;
    },
    currentUser(state) {
      return state.user;
    },
    userPermissions(state) {
      return state.user?.permissions || [];
    },
    userRoles(state) {
      return state.user?.roles || [];
    },
    hasPermission: (state) => (permission) => {
      const permissions = state.user?.permissions || [];
      return permissions.some(p => p.name === permission || p === permission);
    },
    hasAnyPermission: (state) => (permissionArray) => {
      const permissions = state.user?.permissions || [];
      return permissionArray.some(permission => 
        permissions.some(p => p.name === permission || p === permission)
      );
    },
    hasRole: (state) => (role) => {
      const roles = state.user?.roles || [];
      return roles.some(r => r.name === role || r === role);
    },
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.loggedIn = !!user;
    },
  },

  actions: {
    async login({ commit }, credentials) {
      try {
        const userData = await AuthService.login(credentials);
        if (userData?.token) {
          localStorage.setItem("user_free", JSON.stringify(userData));
          commit("SET_USER", userData);
        }
        return userData;
      } catch (error) {
        commit("SET_USER", null);
        throw error;
      }
    },

    async logout({ commit }) {
      try {
        await AuthService.logout();
      } catch (error) {
        // Optional: ignore 401 logout errors
        if (error.response?.status !== 401) {
          throw error;
        }
      }

      localStorage.removeItem("user_free");
      localStorage.removeItem("user_data");
      commit("SET_USER", null);
    },
  },
};
